import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'distanceResult'
})
export class DistanceResultPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: string): string {
    const words = [
      'lengths',
      'length',
      'nose',
      'shortest',
      'short',
      'head',
      'neck',
      'Far behind',
      'Pulled up',
      'Falls down',
      'Disqualified'];
    return this.replaceKeywords(value, words);
  }

  replaceKeywords(text: string, keywords: string[]): string {
    // Creiamo un'espressione regolare unendo le parole chiave
    const regex = new RegExp(keywords.join('|'), 'gi');
    return text.replace(regex, (matched) => this.translate.instant('RACE.' + matched.toUpperCase()));
  }

}
